(function() {
  function getLimitAlertText(max) {
    const jsLocale = (window.Shopify && window.Shopify.locale) ? window.Shopify.locale.toLowerCase() : '';
    const isFrench = jsLocale.startsWith('fr') || window.location.pathname.startsWith('/fr');
    
    if (isFrench) {
      return 'Vous avez atteint la limite maximale autorisée de ' + max + ' pour cet article.';
    }
    return 'You have reached the maximum allowed limit of ' + max + ' for this item.';
  }

  function getTargetMaxLimit(inputOrBtn) {
    if (!inputOrBtn) return null;

    const container = inputOrBtn.closest('tr, .cart-item, .previewCartItem, .productView-quantity, .quantity, [data-cart-item], div');
    const input = container ? container.querySelector('input[name="updates[]"], input[name="quantity"], input[type="number"]') : null;

    // 1. Explicit HTML max attribute on input
    if (input) {
      const maxAttr = parseInt(input.getAttribute('max'), 10);
      if (maxAttr > 0) return maxAttr;
    }

    // 2. Global ShopifyMaxLimits lookup via line item elements or links
    if (window.ShopifyMaxLimits && container) {
      const linksAndInputs = container.querySelectorAll('a[href*="variant="], [data-variant-id], [data-id], [data-key], [name="id"]');
      
      for (const el of linksAndInputs) {
        let val = el.value || el.dataset.variantId || el.dataset.id || el.dataset.key;
        if (!val && el.href && el.href.includes('variant=')) {
          val = el.href.split('variant=')[1].split('&')[0];
        }
        if (val && window.ShopifyMaxLimits[val]) {
          return window.ShopifyMaxLimits[val];
        }
      }
    }

    return null;
  }

  // Override stepUp prototype safely
  const originalStepUp = HTMLInputElement.prototype.stepUp;
  HTMLInputElement.prototype.stepUp = function() {
    const max = getTargetMaxLimit(this);
    if (!max) {
      return originalStepUp.apply(this, arguments);
    }

    const currentVal = parseInt(this.value, 10) || 0;
    const step = arguments[0] || 1;

    if ((currentVal + step) > max) {
      this.value = max;
      alert(getLimitAlertText(max));
      this.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    originalStepUp.apply(this, arguments);
  };

  // Global capture listener for plus (+) button clicks
  document.addEventListener('click', function(e) {
    const plusBtn = e.target.closest('.plus, .btn-quantity.plus, [data-plus-quantity], button[name="plus"], .quantity__button[name="plus"]');
    if (!plusBtn) return;

    const max = getTargetMaxLimit(plusBtn);

    // If item has NO limit, let theme function normally
    if (!max) return;

    const container = plusBtn.closest('tr, .cart-item, .previewCartItem, .productView-quantity, .quantity, div');
    const input = container ? container.querySelector('input') : null;
    if (!input) return;

    const currentVal = parseInt(input.value, 10);

    if (currentVal >= max) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      input.value = max;
      alert(getLimitAlertText(max));
      return false;
    }
  }, true);

  // Global listener for manual key entry
  document.addEventListener('change', function(e) {
    const input = e.target;
    if (input && (input.name === 'updates[]' || input.name === 'quantity' || input.matches('.quantity__input') || input.type === 'number')) {
      const max = getTargetMaxLimit(input);
      if (!max) return;

      const val = parseInt(input.value, 10);
      if (val > max) {
        input.value = max;
        alert(getLimitAlertText(max));
        input.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }
  });
})();